// Mock Data for Mobility Car Rental Platform

export const cars = [
  {
    id: '1',
    name: 'Nissan Versa 2023',
    type: 'SEDAN',
    brand: 'Nissan',
    model: 'Versa',
    year: 2023,
    transmission: 'Automática',
    capacity: 5,
    pricePerDay: 450,
    location: 'Cancún, Quintana Roo',
    locationCoords: { lat: 21.1619, lng: -86.8515 },
    ownerId: 'mob1',
    ownerName: 'Carlos Rodríguez',
    ownerRating: 4.8,
    ownerTrips: 45,
    images: [
      'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800',
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800',
      'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=800'
    ],
    rating: 4.9,
    trips: 32,
    features: ['Aire acondicionado', 'Bluetooth', 'USB', 'ABS'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 200,
    minDays: 1,
    maxDays: 30,
    instantBooking: false,
    available: true,
    deliveryAvailable: true,
    deliveryFee: 100,
    description: 'Auto económico ideal para recorrer la Riviera Maya. Excelente consumo de gasolina y muy cómodo para viajes largos.'
  },
  {
    id: '2',
    name: 'Toyota RAV4 2024',
    type: 'SUV',
    brand: 'Toyota',
    model: 'RAV4',
    year: 2024,
    transmission: 'Automática',
    capacity: 7,
    pricePerDay: 850,
    location: 'Ciudad de México, CDMX',
    locationCoords: { lat: 19.4326, lng: -99.1332 },
    ownerId: 'mob2',
    ownerName: 'María González',
    ownerRating: 5.0,
    ownerTrips: 78,
    images: [
      'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800',
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800',
      'https://images.unsplash.com/photo-1611859266238-4b98091d9d9b?w=800',
      'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=800'
    ],
    rating: 5.0,
    trips: 56,
    features: ['Aire acondicionado', 'Bluetooth', '4x4', 'Cámara reversa', 'Sensores'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 250,
    minDays: 1,
    maxDays: 30,
    instantBooking: true,
    available: true,
    deliveryAvailable: true,
    deliveryFee: 150,
    description: 'SUV espaciosa perfecta para familias. Equipada con todas las comodidades modernas y excelente para viajes largos.'
  },
  {
    id: '3',
    name: 'Jeep Wrangler 2023',
    type: 'JEEP',
    brand: 'Jeep',
    model: 'Wrangler',
    year: 2023,
    transmission: 'Manual',
    capacity: 5,
    pricePerDay: 1200,
    location: 'Playa del Carmen, Quintana Roo',
    locationCoords: { lat: 20.6296, lng: -87.0739 },
    ownerId: 'mob1',
    ownerName: 'Carlos Rodríguez',
    ownerRating: 4.8,
    ownerTrips: 45,
    images: [
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800',
      'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800',
      'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=800',
      'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800'
    ],
    rating: 4.7,
    trips: 28,
    features: ['4x4', 'Techo removible', 'Bluetooth', 'Todo terreno'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 300,
    minDays: 2,
    maxDays: 15,
    instantBooking: false,
    available: true,
    deliveryAvailable: false,
    deliveryFee: 0,
    description: 'Aventura pura. Ideal para explorar playas y selva. Experiencia única en Riviera Maya.'
  },
  {
    id: '4',
    name: 'Ford F-150 2023',
    type: 'PICKUP',
    brand: 'Ford',
    model: 'F-150',
    year: 2023,
    transmission: 'Automática',
    capacity: 5,
    pricePerDay: 950,
    location: 'Guadalajara, Jalisco',
    locationCoords: { lat: 20.6597, lng: -103.3496 },
    ownerId: 'mob3',
    ownerName: 'Roberto Sánchez',
    ownerRating: 4.6,
    ownerTrips: 34,
    images: [
      'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800',
      'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800',
      'https://images.unsplash.com/photo-1506521781263-d8422e82f27a?w=800',
      'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=800'
    ],
    rating: 4.5,
    trips: 25,
    features: ['Aire acondicionado', 'Bluetooth', 'Caja de carga', '4x4'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 250,
    minDays: 1,
    maxDays: 30,
    instantBooking: false,
    available: true,
    deliveryAvailable: true,
    deliveryFee: 200,
    description: 'Pickup robusta ideal para trabajo o aventuras. Gran capacidad de carga y confort.'
  },
  {
    id: '5',
    name: 'Honda Civic 2024',
    type: 'SEDAN',
    brand: 'Honda',
    model: 'Civic',
    year: 2024,
    transmission: 'Automática',
    capacity: 5,
    pricePerDay: 550,
    location: 'Monterrey, Nuevo León',
    locationCoords: { lat: 25.6866, lng: -100.3161 },
    ownerId: 'mob4',
    ownerName: 'Ana Martínez',
    ownerRating: 4.9,
    ownerTrips: 62,
    images: [
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800',
      'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800',
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=800',
      'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=800'
    ],
    rating: 4.8,
    trips: 48,
    features: ['Aire acondicionado', 'Bluetooth', 'Cámara reversa', 'Sensores', 'CarPlay'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 200,
    minDays: 1,
    maxDays: 30,
    instantBooking: true,
    available: true,
    deliveryAvailable: true,
    deliveryFee: 100,
    description: 'Sedán moderno y confiable. Perfecto para ciudad y carretera. Muy económico en gasolina.'
  },
  {
    id: '6',
    name: 'Mazda CX-5 2023',
    type: 'SUV',
    brand: 'Mazda',
    model: 'CX-5',
    year: 2023,
    transmission: 'Automática',
    capacity: 5,
    pricePerDay: 720,
    location: 'Ciudad Juárez, Chihuahua',
    locationCoords: { lat: 31.6904, lng: -106.4245 },
    ownerId: 'mob5',
    ownerName: 'Luis Fernández',
    ownerRating: 4.7,
    ownerTrips: 51,
    images: [
      'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800',
      'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800',
      'https://images.unsplash.com/photo-1611859266238-4b98091d9d9b?w=800',
      'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=800'
    ],
    rating: 4.6,
    trips: 39,
    features: ['Aire acondicionado', 'Bluetooth', 'Cámara 360°', 'Asientos piel', 'Quemacocos'],
    fuelPolicy: 'full-to-full',
    mileageLimit: 200,
    minDays: 1,
    maxDays: 30,
    instantBooking: false,
    available: true,
    deliveryAvailable: true,
    deliveryFee: 120,
    description: 'SUV elegante con tecnología de punta. Ideal para viajes de negocios o placer.'
  }
];

export const users = [
  {
    id: 'user1',
    email: 'juan.perez@email.com',
    name: 'Juan Pérez',
    phone: '+52 555 123 4567',
    role: 'user',
    verified: true,
    license: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      verified: true
    },
    rating: 4.9,
    trips: 12,
    joinedDate: '2023-05-15',
    favorites: ['1', '2', '5']
  },
  {
    id: 'user2',
    email: 'sofia.lopez@email.com',
    name: 'Sofía López',
    phone: '+52 555 987 6543',
    role: 'user',
    verified: true,
    license: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      verified: true
    },
    rating: 5.0,
    trips: 8,
    joinedDate: '2023-08-20',
    favorites: ['3', '4']
  }
];

export const mobilitiers = [
  {
    id: 'mob1',
    email: 'carlos.rodriguez@email.com',
    name: 'Carlos Rodríguez',
    phone: '+52 998 111 2222',
    role: 'mobilitier',
    verified: true,
    stripeConnected: true,
    stripeAccountId: 'acct_test_123',
    rating: 4.8,
    trips: 45,
    earnings: 24500,
    cars: ['1', '3'],
    joinedDate: '2022-11-10',
    responseTime: '2 horas',
    responseRate: 95
  },
  {
    id: 'mob2',
    email: 'maria.gonzalez@email.com',
    name: 'María González',
    phone: '+52 555 333 4444',
    role: 'mobilitier',
    verified: true,
    stripeConnected: true,
    stripeAccountId: 'acct_test_456',
    rating: 5.0,
    trips: 78,
    earnings: 48900,
    cars: ['2'],
    joinedDate: '2022-06-05',
    responseTime: '1 hora',
    responseRate: 98
  },
  {
    id: 'mob3',
    email: 'roberto.sanchez@email.com',
    name: 'Roberto Sánchez',
    phone: '+52 333 555 6666',
    role: 'mobilitier',
    verified: true,
    stripeConnected: true,
    stripeAccountId: 'acct_test_789',
    rating: 4.6,
    trips: 34,
    earnings: 18700,
    cars: ['4'],
    joinedDate: '2023-01-20',
    responseTime: '3 horas',
    responseRate: 90
  },
  {
    id: 'mob4',
    email: 'ana.martinez@email.com',
    name: 'Ana Martínez',
    phone: '+52 818 777 8888',
    role: 'mobilitier',
    verified: true,
    stripeConnected: true,
    stripeAccountId: 'acct_test_101',
    rating: 4.9,
    trips: 62,
    earnings: 32100,
    cars: ['5'],
    joinedDate: '2022-09-12',
    responseTime: '1.5 horas',
    responseRate: 96
  },
  {
    id: 'mob5',
    email: 'luis.fernandez@email.com',
    name: 'Luis Fernández',
    phone: '+52 656 999 0000',
    role: 'mobilitier',
    verified: true,
    stripeConnected: true,
    stripeAccountId: 'acct_test_202',
    rating: 4.7,
    trips: 51,
    earnings: 27800,
    cars: ['6'],
    joinedDate: '2022-12-08',
    responseTime: '2.5 horas',
    responseRate: 92
  }
];

export const bookings = [
  {
    id: 'book1',
    carId: '2',
    userId: 'user1',
    mobilitierId: 'mob2',
    status: 'pending',
    startDate: '2025-04-15',
    endDate: '2025-04-18',
    days: 3,
    pricePerDay: 850,
    totalPrice: 2550,
    deposit: 750,
    platformFee: 510,
    ownerEarnings: 2040,
    pickupLocation: 'Ciudad de México, CDMX',
    deliveryRequested: false,
    createdAt: '2025-04-06T10:30:00Z',
    licensePhotos: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400'
    }
  },
  {
    id: 'book2',
    carId: '1',
    userId: 'user2',
    mobilitierId: 'mob1',
    status: 'confirmed',
    startDate: '2025-04-10',
    endDate: '2025-04-12',
    days: 2,
    pricePerDay: 450,
    totalPrice: 900,
    deposit: 500,
    platformFee: 180,
    ownerEarnings: 720,
    pickupLocation: 'Cancún, Quintana Roo',
    deliveryRequested: true,
    deliveryFee: 100,
    createdAt: '2025-04-01T14:20:00Z',
    confirmedAt: '2025-04-01T16:45:00Z',
    paymentIntentId: 'pi_test_123',
    licensePhotos: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400'
    }
  },
  {
    id: 'book3',
    carId: '5',
    userId: 'user1',
    mobilitierId: 'mob4',
    status: 'active',
    startDate: '2025-04-06',
    endDate: '2025-04-09',
    days: 3,
    pricePerDay: 550,
    totalPrice: 1650,
    deposit: 600,
    platformFee: 330,
    ownerEarnings: 1320,
    pickupLocation: 'Monterrey, Nuevo León',
    deliveryRequested: false,
    createdAt: '2025-03-30T09:15:00Z',
    confirmedAt: '2025-03-30T10:00:00Z',
    startedAt: '2025-04-06T08:00:00Z',
    paymentIntentId: 'pi_test_456',
    checkIn: {
      photos: [
        'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400',
        'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=400'
      ],
      odometer: 45230,
      fuelLevel: 'full',
      timestamp: '2025-04-06T08:00:00Z'
    },
    licensePhotos: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400'
    }
  },
  {
    id: 'book4',
    carId: '3',
    userId: 'user2',
    mobilitierId: 'mob1',
    status: 'completed',
    startDate: '2025-03-20',
    endDate: '2025-03-23',
    days: 3,
    pricePerDay: 1200,
    totalPrice: 3600,
    deposit: 800,
    platformFee: 720,
    ownerEarnings: 2880,
    pickupLocation: 'Playa del Carmen, Quintana Roo',
    deliveryRequested: false,
    createdAt: '2025-03-15T11:00:00Z',
    confirmedAt: '2025-03-15T12:30:00Z',
    startedAt: '2025-03-20T10:00:00Z',
    completedAt: '2025-03-23T18:00:00Z',
    paymentIntentId: 'pi_test_789',
    checkIn: {
      photos: [
        'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400',
        'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=400'
      ],
      odometer: 32100,
      fuelLevel: 'full',
      timestamp: '2025-03-20T10:00:00Z'
    },
    checkOut: {
      photos: [
        'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=400',
        'https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=400'
      ],
      odometer: 32650,
      fuelLevel: 'full',
      timestamp: '2025-03-23T18:00:00Z'
    },
    review: {
      rating: 5,
      comment: 'Experiencia increíble! El auto estaba impecable y Carlos fue muy atento.',
      timestamp: '2025-03-24T10:00:00Z'
    },
    licensePhotos: {
      front: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400',
      back: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=400'
    }
  }
];

export const reviews = [
  {
    id: 'rev1',
    bookingId: 'book4',
    carId: '3',
    userId: 'user2',
    mobilitierId: 'mob1',
    rating: 5,
    comment: 'Experiencia increíble! El auto estaba impecable y Carlos fue muy atento.',
    response: 'Gracias Sofía! Fue un placer rentarte el Jeep. Espero verte pronto!',
    createdAt: '2025-03-24T10:00:00Z'
  },
  {
    id: 'rev2',
    bookingId: 'book5',
    carId: '2',
    userId: 'user1',
    mobilitierId: 'mob2',
    rating: 5,
    comment: 'María es una excelente Mobilitier. El RAV4 es perfecto para familias.',
    response: 'Muchas gracias Juan! Siempre es un placer.',
    createdAt: '2025-03-15T14:30:00Z'
  }
];

export const messages = [
  {
    id: 'msg1',
    bookingId: 'book1',
    senderId: 'user1',
    receiverId: 'mob2',
    message: 'Hola María, ¿el auto tiene quemacocos?',
    timestamp: '2025-04-06T11:00:00Z',
    read: true
  },
  {
    id: 'msg2',
    bookingId: 'book1',
    senderId: 'mob2',
    receiverId: 'user1',
    message: 'Hola Juan! Sí, el RAV4 tiene quemacocos y asientos de piel. ¿Alguna otra duda?',
    timestamp: '2025-04-06T11:15:00Z',
    read: true
  },
  {
    id: 'msg3',
    bookingId: 'book1',
    senderId: 'user1',
    receiverId: 'mob2',
    message: 'Perfecto, entonces confirmo la reserva!',
    timestamp: '2025-04-06T11:20:00Z',
    read: true
  },
  {
    id: 'msg4',
    bookingId: 'book2',
    senderId: 'mob1',
    receiverId: 'user2',
    message: 'Hola Sofía, tu reserva está confirmada. Te veo el 10 de abril a las 9am en el aeropuerto.',
    timestamp: '2025-04-01T17:00:00Z',
    read: false
  }
];

export const locations = [
  'Cancún, Quintana Roo',
  'Ciudad de México, CDMX',
  'Playa del Carmen, Quintana Roo',
  'Guadalajara, Jalisco',
  'Monterrey, Nuevo León',
  'Ciudad Juárez, Chihuahua',
  'Tijuana, Baja California',
  'Mérida, Yucatán',
  'Puebla, Puebla',
  'Tulum, Quintana Roo'
];

export const carTypes = [
  { value: 'SEDAN', label: 'Sedán', icon: '🚗' },
  { value: 'SUV', label: 'SUV', icon: '🚙' },
  { value: 'PICKUP', label: 'Pickup', icon: '🚚' },
  { value: 'JEEP', label: 'Jeep', icon: '🚕' }
];

export const transmissionTypes = [
  { value: 'Automática', label: 'Automática' },
  { value: 'Manual', label: 'Manual' }
];

export const admin = {
  id: 'admin1',
  email: 'admin@mobility.com',
  name: 'Admin Mobility',
  role: 'admin'
};

export const platformStats = {
  totalUsers: 1234,
  totalMobilitiers: 456,
  totalCars: 892,
  totalBookings: 3456,
  activeBookings: 234,
  totalRevenue: 1250000,
  platformFees: 250000,
  monthlyRevenue: 125000,
  monthlyBookings: 345
};